export default __webpack_public_path__ + "static/media/480_dummy2016-klempner01-de.6255a883.png";